import { render } from "./EditReferentePage.vue?vue&type=template&id=0b37a4e8"
import script from "./EditReferentePage.vue?vue&type=script&lang=js"
export * from "./EditReferentePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__